// import the original component so that base styles are applied first
import 'SourceComponent/Image/Image.component';
// import our modified styles to override some of the default ones
import './Image.override.style.scss';

// re-export all the original exports from the parent theme untouched
export * from 'SourceComponent/Image/Image.component';
export { default } from 'SourceComponent/Image/Image.component';